export const DISABLE_DISTRICTS_OR_SURROUNDINGS_FOR_MAP_VIEW = [
    53406 // Kraków, Bieżanów
];
